import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { toast } from 'react-toastify';
import moment from 'moment';
import { prepareCustomerOfferTemplateData } from '../../utils/prepareTemplateData';
import PrintDocxButton from '../../utils/PrintDocxButton';



export default function DGLTH_customer_offer({ item, entity = null, refreshData }) {

    const navigate = useNavigate();


    async function convertIntoOrder() {
        var resOffer = await DataManager.getItem('customer_offer', item.id);
        console.log(resOffer);
        const data = resOffer.body[0];
        data.idCustomerOffer = item.id;
        data.orderDate = moment().format('YYYY-MM-DD');
        data.status = { value: '0_PENDING' }
        delete data.offerType;
        delete data.offerDate;
        console.log(data);
        var insertOrder = await DataManager.insertItem('customer_order', data);
        console.log(insertOrder);
        if (insertOrder.success === 1) {

            const uStatus = {
                status: { value: '20_COMPLETED' }
            }
            var resUpdateStatus = await DataManager.updateItem('customer_offer', uStatus, item.id)
            if (resUpdateStatus.success === 1) {
                toast.success('Preventivo convertito con successo!', { theme: 'colored' })
                refreshData();
            }
        }
    }


    function sendEmail() {
        navigate('/page/SendDocumentEmailCustomerOffer?id=' + item.id + '&e=customer_offer')
    }

    async function loadPrintData() {
        const res = await DataManager.getItem('customer_offer', item.id);
        if (res.success !== 1) return null;
        const data = res.body[0];
        return {
            fileDocument: data.fileDocument,
            templateData: prepareCustomerOfferTemplateData(data),
            filename: 'preventivo_' + data.internalCode,
            entity: 'customer_offer',
            id: item.id
        };
    }



    return (
        <>
            {item.status.value === '0_PENDING' ? <Button size='sm' variant='success' className='me-1' onClick={() => convertIntoOrder()}>Converti</Button> : <></>}

            <PrintDocxButton
                templateKey="template_offer_customer"
                loadData={loadPrintData}
            />
            <Button size='sm' variant='outline-primary' className='me-1' onClick={() => sendEmail()}>Invia email</Button>
        </>
    )
}
